export { IconLogoRest, IconLogoText } from './Logo'
